module.exports = __webpack_public_path__ + "img/logo.00aa02b8.png";